
<div id="shape" role="tabpanel" class="tab-pane active collapse show" style="margin-left:130px;">
  <spinner [id]="'centershapefile'" [show]='activespineer'></spinner>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
      <div class="form-group text-left">
          <label>State<span class="text-star">*</span></label>
      </div>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
    <div class="form-group">
        <select [(ngModel)]="shapefileupload['state']" disabled=""  class="form-control custom-selectbox selectdis">
            <option *ngIf="!shapefileupload['state']">Select State</option>
            <option *ngFor="let state of userdetails['loggedUserData']['userProfile']['associatedlocationsDetails']" value="{{state['entityUUID']}}">{{state['entityName']}}</option>
          </select>
    </div>
  </div>
  </div>
  <div class="col-lg-12">
      <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
              <div class="form-group text-left" style="margin-left: -11px;">
                  <label>Assessment Unit Shape File Upload:<span class="text-star">*</span></label>
              </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
              <div class="form-group col-12">
                  <input type="file" id="fileupload" (change)="fileuploadchange($event,'aquiferfile')" name="file" class="form-control">
              </div>
              <span style="color:red" [hidden]="validation[0]">Please select valid file </span>
          </div>
          <!-- <div class="col-xs-12 col-sm-12 col-md-1 col-lg-1">
            <a href="#" class="text-right" style="color:white" data-toggle="tooltip" data-placement="top" title="Give proper color [ Ex:red or #FFFF00 ]"> <i class="fa fa-info-circle"></i></a>
          </div> -->
          <div class="col-xs-12 col-sm-12 col-md-1 col-lg-1" align="center">
              <button type="button" style="width:100%" (click)="uploadfile('aquiferfile')" class="btn btn-info">Upload</button>
              <!-- <button class="btn btn-info pointer" (click)="uploadfile('aquiferfile')" type="submit">Submit</button> -->
          </div>
      </div>
      
     
  </div>
  <div class="row" *ngIf="shapefileflag">
    <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
      <div class="form-group text-left">
          <label>Assesment Year<span class="text-star">*</span></label>
      </div>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
    <div class="form-group">
        <select [(ngModel)]="shapefileupload['assesmentyear']"  class="form-control custom-selectbox selectdis">
          <option value="">Select Assessment Year</option>
          <option *ngFor="let year of fieldDropDownList['AssesmentYearList']" value="{{year}}">{{year}}</option>
        </select>
        <span style="color:red" [hidden]="validation[1]">Please Select Assesment Year </span>
    </div>
  </div>
  </div>
  <div class="row" *ngIf="shapefileflag">
    <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
      <div class="form-group text-left">
          <label>Assesment Hierarchy<span class="text-star">*</span></label>
      </div>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
    <div class="form-group">
      <label>{{shapefileupload['hierarchy']}}</label>
    </div>
  </div>
  </div>
  <div class="row" *ngIf="shapefileflag">
    <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
      <div class="form-group text-left">
          <label>Assesment Unit<span class="text-star">*</span></label>
      </div>
      
  </div>
  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
    <div class="form-group">
      <!-- <select [(ngModel)]="shapefileupload['unit']" class="form-control custom-selectbox selectdis">
        <option value="">Select Assesment Unit</option>
        <option *ngFor="let unit of shapefileresponse['h_list']" value="{{unit}}">{{unit}}</option>
      </select>
      <span style="color:red" [hidden]="validation[2]">Please Select Assesment Unit </span> -->
      <label>{{shapefileupload['unit']}}</label>
    </div>
  </div>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2" align="center" style="margin-left: 399px;" *ngIf="shapefileflag">
    <button type="button" style="width:100%" (click)="submitdata()" class="btn btn-info">Submit</button>
</div>
</div>